export const SET_LOADER = "SET_LOADER";

export function setLoader(value){
    return{
        type: SET_LOADER,
        payload: value
    }
}